/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_Return_Position_PlaceholderInputs */

const vi_confirm_return_position_placeholder = /** @type {(inputs: Confirm_Return_Position_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giữ vị trí hiện tại`)
};

/**

* @param {Confirm_Return_Position_PlaceholderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const confirm_return_position_placeholder = /** @type {((inputs?: Confirm_Return_Position_PlaceholderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Return_Position_PlaceholderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_confirm_return_position_placeholder(inputs)
});